import { userConstants } from "../../constant";

const initialState = {
  folders: [],
  unfiled_count: 0,
};

export function wishlistFolders(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_WISHLIST_FOLDERS:
      return {
        ...state,
        folders: action.payload.folders || [],
        unfiled_count: action.payload.unfiled_count || 0,
      };
    default:
      return state;
  }
}
